import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from './config.service';

export interface UserAccount {
  userAccountID: number;
  fullName: string;
  address?: string;
  address2?: string;
  zipCode?: string;
  city?: string;
  email?: string;
  phone?: string;
  domainCount: number;
}

export interface SaveUserAccountRequest {
  userAccountID?: number;
  fullName: string;
  address?: string;
  address2?: string;
  zipCode?: string;
  city?: string;
  email?: string;
  phone?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SystemUserAccountService {
  private apiUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.apiUrl = `${this.configService.get('apiBaseUrl')}/SystemUserAccount`;
  }

  /**
   * Get all user accounts
   */
  getAllUserAccounts(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}`).pipe(
      map((response: any) => response)
    );
  }

  /**
   * Get user account by ID
   */
  getUserAccountById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`).pipe(
      map((response: any) => response)
    );
  }

  /**
   * Create new user account
   */
  createUserAccount(request: SaveUserAccountRequest): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}`, request).pipe(
      map((response: any) => response)
    );
  }

  /**
   * Update existing user account
   */
  updateUserAccount(id: number, request: SaveUserAccountRequest): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, request).pipe(
      map((response: any) => response)
    );
  }

  /**
   * Delete user account
   */
  deleteUserAccount(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`).pipe(
      map((response: any) => response)
    );
  }

  /**
   * Get count of domains using this user account
   */
  getDomainCount(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}/DomainCount`).pipe(
      map((response: any) => response)
    );
  }
}
